import { Spin } from '@faceup/ui-base'

export const FullPageSpin = () => (
  <div className='flex h-[100vh] w-full items-center justify-center'>
    <Spin size='large' />
  </div>
)
